module.exports = __webpack_public_path__ + "media/images/admin/icons/droplet-49d3b1343e88b01d4777efaff5589121.svg";